<button class="topbar-toggle" type="button" aria-label="Toggle navigation" (click)="toggleSidebar.emit()">
  <svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5" width="16" height="16">
    <path d="M1.5 3.5h11M1.5 7h11M1.5 10.5h11" />
  </svg>
</button>

<div class="topbar-breadcrumb">
  @for (c of crumbs(); track $index; let last = $last) {
    @if ($index > 0) {
      <span class="sep" [class.hide-mobile]="!last">/</span>
    }
    @if (last || !c[1]) {
      <span class="topbar-breadcrumb-current" [class.hide-mobile]="!last">{{ c[0] }}</span>
    } @else {
      <a [routerLink]="['/', c[1]]" [class.hide-mobile]="!last">{{ c[0] }}</a>
    }
  }
</div>

<div class="topbar-search">
  <svg class="topbar-search-icon" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5">
    <circle cx="6" cy="6" r="4" />
    <path d="M9 9l3.5 3.5" />
  </svg>
  <input type="text" placeholder="Search Contacts, Opportunities, Documents&hellip;" aria-label="Search" />
</div>

<div class="topbar-actions">
  <div class="topbar-bell-wrapper">
    <button
      class="topbar-icon-btn"
      type="button"
      aria-label="Notifications"
      title="Notifications"
      aria-haspopup="true"
      [attr.aria-expanded]="bellOpen()"
      (click)="toggleBell()"
    >
      <svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5" width="14" height="14" aria-hidden="true">
        <path d="M3 5.5a4 4 0 018 0V8l1 2.5H2L3 8z" />
        <path d="M5.5 11.5a1.5 1.5 0 003 0" />
      </svg>
      @if (notifications.unreadCount() > 0) {
        <span class="badge-count">{{ notifications.unreadCount() }}</span>
      }
    </button>

    @if (bellOpen()) {
      <div class="topbar-dropdown-backdrop" (click)="closeBell()"></div>
      <div class="topbar-dropdown topbar-dropdown-notifications" role="menu" aria-label="Notifications">
        <div class="notifications-header">
          <span class="notifications-header-title">Notifications</span>
        </div>

        @if (notifications.loadingRecent()) {
          <div class="notifications-empty">Loading&hellip;</div>
        } @else if (notifications.recent().length === 0) {
          <div class="notifications-empty">No notifications yet.</div>
        } @else {
          <ul class="notifications-list">
            @for (n of notifications.recent(); track n.id) {
              <li
                class="notification-item"
                [class.notification-item--unread]="!n.readAt"
                role="menuitem"
                tabindex="0"
                (click)="openNotification(n)"
                (keydown.enter)="openNotification(n)"
              >
                <span class="notification-item-dot" [class.notification-item-dot--read]="n.readAt"></span>
                <div class="notification-item-content">
                  <div class="notification-item-title">{{ n.title }}</div>
                  <div class="notification-item-body">{{ n.body }}</div>
                  <div class="notification-item-time">{{ timeAgo(n.createdAt) }}</div>
                </div>
                @if (!n.readAt) {
                  <button
                    class="notification-item-mark-read"
                    type="button"
                    aria-label="Mark as read"
                    title="Mark as read"
                    (click)="markNotificationRead(n, $event)"
                  >
                    <svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5" width="10" height="10" aria-hidden="true">
                      <path d="M2.5 7l3 3 6-6" />
                    </svg>
                  </button>
                }
              </li>
            }
          </ul>
        }

        <div class="topbar-dropdown-divider"></div>
        <a class="topbar-dropdown-item" routerLink="/notifications" (click)="closeBell()" role="menuitem">View all</a>
      </div>
    }
  </div>
  <div class="topbar-user-wrapper" [class.open]="dropdownOpen()">
    <div class="topbar-user"
         tabindex="0"
         role="button"
         aria-haspopup="true"
         [attr.aria-expanded]="dropdownOpen()"
         (click)="toggleDropdown()"
         (keydown.enter)="toggleDropdown()"
         (keydown.space)="$event.preventDefault(); toggleDropdown()">
      <div class="topbar-user-avatar">{{ user().initials }}</div>
      <div class="topbar-user-text">
        <div class="topbar-user-name">{{ user().name }}</div>
        <div class="topbar-user-role">{{ user().role.toUpperCase() }} &middot; {{ user().entityShort }}</div>
      </div>
      <svg class="topbar-user-chevron" viewBox="0 0 10 6" fill="none" stroke="currentColor" stroke-width="1.5" width="10" height="6" aria-hidden="true">
        <path d="M1 1l4 4 4-4" />
      </svg>
    </div>
    @if (dropdownOpen()) {
      <div class="topbar-dropdown-backdrop" (click)="closeDropdown()"></div>
      <div class="topbar-dropdown" role="menu">
        <a class="topbar-dropdown-item" routerLink="/profile" (click)="closeDropdown()" role="menuitem">
          <svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5" width="14" height="14" aria-hidden="true">
            <circle cx="7" cy="5" r="2.5" />
            <path d="M1.5 12.5c0-2.76 2.46-5 5.5-5s5.5 2.24 5.5 5" />
          </svg>
          Profile
        </a>
        <div class="topbar-dropdown-divider"></div>
        <button class="topbar-dropdown-item topbar-dropdown-item--danger" type="button" (click)="logout()" role="menuitem">
          <svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5" width="14" height="14" aria-hidden="true">
            <path d="M4 2H1.5v10H4M12.5 7H5.5M12.5 7l-3-3M12.5 7l-3 3" />
          </svg>
          Sign out
        </button>
      </div>
    }
  </div>
</div>

